import React, { useState, useEffect } from 'react'
import { CAlert } from '@coreui/react'
import { CIcon } from '@coreui/icons-react'
import { cilWarning, cilCheckCircle } from '@coreui/icons'
import { useAuth } from '../utils/AuthContext'
import { fetchCompleteProfile } from '../../utils/api'

const StatusBanner = () => {
  const { user } = useAuth()
  const [companyStatus, setCompanyStatus] = useState('pending')
  const [showStatusBanner, setShowStatusBanner] = useState(false)

    useEffect(() => {
        if (user?.id) {
            loadCompanyStatus(user.id)
        }
    }, [user])

    const loadCompanyStatus = async (userId) => {
        try {
            console.log('Loading company status for sidebar:', userId)
            const response = await fetchCompleteProfile(userId)

            if (response.status === 'success' && response.data?.company) {
                const status = response.data.company.status || response.data.company.verification_status || 'pending'
                console.log('Company status loaded for sidebar:', status)
                setCompanyStatus(status)
                setShowStatusBanner(true)
            } else {
                console.log('No company data found for sidebar')
                setCompanyStatus('pending')
                setShowStatusBanner(false)
            }
        } catch (error) {
            console.error('Error loading company status for sidebar:', error)
            setCompanyStatus('pending')
            setShowStatusBanner(false)
        }
    }

    if (!showStatusBanner) return null

    if (companyStatus === 'pending') {
        return (
      <CAlert 
        color="warning" 
        className="mb-3 mx-3"
        style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '8px'
        }}
      >
        <div className="d-flex align-items-start">
          <CIcon icon={cilWarning} className="me-2 mt-1" style={{ color: '#856404' }} />
          <div className="flex-grow-1">
            <strong style={{ color: '#856404', fontSize: '0.9rem' }}>Documents Pending</strong>
            <p className="mb-2 mt-1" style={{ color: '#856404', fontSize: '0.8rem' }}>
              You can change your documents before admin verification. Click on Company Profile and re-upload.
            </p>
          </div>
        </div>
      </CAlert>
        )
    } else if (companyStatus === 'approved') {
        return (
      <CAlert 
        color="success" 
        className="mb-3 mx-3"
        style={{
          backgroundColor: '#d1edff',
          border: '1px solid #198754',
          borderRadius: '8px'
        }}
      >
        <div className="d-flex align-items-start">
          <CIcon icon={cilCheckCircle} className="me-2 mt-1" style={{ color: '#0f5132' }} />
          <div className="flex-grow-1">
            <strong style={{ color: '#0f5132', fontSize: '0.9rem' }}>Documents Approved!</strong>
            <p className="mb-2 mt-1" style={{ color: '#0f5132', fontSize: '0.8rem' }}>
              Your documents are already approved, you cannot change them.
            </p>
          </div>
        </div>
      </CAlert>
        )
    } else if (companyStatus === 'rejected') {
        return (
      <CAlert 
        color="danger" 
        className="mb-3 mx-3"
        style={{
          backgroundColor: '#f8d7da',
          border: '1px solid #dc3545',
          borderRadius: '8px'
        }}
      >
        <div className="d-flex align-items-start">
          <CIcon icon={cilWarning} className="me-2 mt-1" style={{ color: '#721c24' }} />
          <div className="flex-grow-1">
            <strong style={{ color: '#721c24', fontSize: '0.9rem' }}>Documents Rejected</strong>
            <p className="mb-2 mt-1" style={{ color: '#721c24', fontSize: '0.8rem' }}>
              Your documents have been rejected. Please upload new documents and resubmit.
            </p>
          </div>
        </div>
      </CAlert>
        )
    }
    return null
}

export default StatusBanner
